/**
 * task-history-store — tiny localStorage helper for task-ID recovery.
 *
 * Key:  botwork_task_ids
 * Format: JSON array of string IDs, newest-first, capped at 100.
 *
 * Both helpers guard against SSR (typeof window check) so they are
 * safe to import from "use client" modules that also run on the server.
 */

const KEY = "botwork_task_ids";
const CAP = 100;

export function addTaskId(id: string): void {
  if (typeof window === "undefined") return;
  try {
    const existing = getTaskIds();
    // Dedup: remove any prior occurrence, then prepend.
    const deduped = [id, ...existing.filter((x) => x !== id)];
    const capped = deduped.slice(0, CAP);
    window.localStorage.setItem(KEY, JSON.stringify(capped));
  } catch {
    // localStorage may be unavailable (private-browsing quota, etc.) — ignore.
  }
}

export function getTaskIds(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === "string");
  } catch {
    return [];
  }
}
